window.onload = function(){
    // スマホで:activeを効かせるための対応
    //document.getElementsByTagName("body")[0].ontouchstart = function(){};
    document.querySelector("body").addEventListener("touchstart", function(){}, false);
    
    // IE11で、background-attachment:fixedやposition:fixedを設定した要素が、スクロールでカクつくための対応
    // ※スムーススクロール設定を解除する
    if(navigator.userAgent.toLowerCase().match(/rv:11/i) || navigator.userAgent.toLowerCase().match(/trident\/7\./)) {
        let ie11_fixed_bugfix = function(event){
            event.preventDefault();
            var wd = event.wheelDelta;
            var csp = window.pageYOffset;
            window.scrollTo(0, csp - wd);
        };
        document.querySelector("body").addEventListener("mousewheel", ie11_fixed_bugfix, false);
        
        // イベントを解除するには、以下の様に設定
        //document.querySelector("body").removeEventListener("mousewheel", ie11_fixed_bugfix);
    }
};

(function($){

    $(function(){
        // トップページスライダー
        $(".slider").slider();
        // メニュー開閉
        $("#global_navi").on({
            click: function(e){
                if(e.target.id == "global_navi"){
                    $("body").toggleClass("menu_open");
                }
            }
        });

        // スクロールイベントを設定
        $(window).scroll(function(e){
            naviScrollEvent();
        });
        // ページ読み込み時にも実行
        naviScrollEvent();

        // ヘッダーsticky状態変更処理
        function naviScrollEvent(){
            // 現在のスクロール位置
            let scrollPosition = $(window).scrollTop();

            if(scrollPosition > 300){
                // ヘッダーをstickyから元に戻す
                $("body").addClass("global_header_sticky");
            }else{
                // ヘッダーをsticky状態にする
                $("body").removeClass("global_header_sticky");
            }
        }

        // スクロールインアニメーション
        $(window).scrollIn({"interval": 100});

        $(".has_child > span, .has_child > a").on("click", function(){
            $(this).closest(".has_child").toggleClass("child_open");
        });
        
    });

    // 年齢確認
    $(window).on({
        load: function() {
            if( !($.cookie('age')) ) {
                $("body").addClass("age_open");
                $(".f_age").addClass('is-active');
            }
        },
    })
    $( ".f_age .yes" ).on({
        click: function() {
            $("body").removeClass("age_open");
            $.cookie('age', 'yes', { expires: 1 });
            $(".f_age").removeClass('is-active');
        }
    })
})(jQuery);